export default __webpack_public_path__ + "static/media/milano-thumbnail.a8d171ca.png";